import * as React from "react";

import Button from "../Button";

import "./dropper.scss";

const Dropper = (props) => {
  const {
    className,
    buttonLabel,
    buttonProps = { variant: "dark" },
    children,
    isOpen,
    onClick,
  } = props;

  const [active, setActive] = React.useState(isOpen);

  React.useEffect(() => {
    setActive(isOpen);
  }, [isOpen]);

  const onClickButton = () => {
    onClick?.(!active);
    setActive(!active);
  };

  return (
    <div className={`dropper ${className || ""}`}>
      <Button {...buttonProps} onClick={onClickButton}>
        {buttonLabel}
      </Button>
      {active && <div className="backdrop" onClick={onClickButton} />}
      <div className={`dropper-content ${active ? "show" : ""}`}>
        {children}
      </div>
    </div>
  );
};

export default Dropper;
